"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStoredPaymentMethodType = exports.StoredPaymentMethodType = exports.StoredPaymentMethodTypes = exports.STORED_PAYMENT_METHOD_VENMO = exports.STORED_PAYMENT_METHOD_PAYPAL_WALLET = exports.STORED_PAYMENT_METHOD_APPLE_PAY = exports.STORED_PAYMENT_METHOD_ACH = exports.STORED_PAYMENT_METHOD_CARD = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.STORED_PAYMENT_METHOD_CARD = 'CARD';
exports.STORED_PAYMENT_METHOD_ACH = 'ACH';
exports.STORED_PAYMENT_METHOD_APPLE_PAY = 'APPLE_PAY';
// Doesn't include PayPal Pay Later, as Pay Later can't be stored as a Rainforest payment method
exports.STORED_PAYMENT_METHOD_PAYPAL_WALLET = 'PAYPAL_WALLET';
exports.STORED_PAYMENT_METHOD_VENMO = 'VENMO';
exports.StoredPaymentMethodTypes = [
    exports.STORED_PAYMENT_METHOD_CARD,
    exports.STORED_PAYMENT_METHOD_ACH,
    exports.STORED_PAYMENT_METHOD_APPLE_PAY,
    exports.STORED_PAYMENT_METHOD_PAYPAL_WALLET,
    exports.STORED_PAYMENT_METHOD_VENMO,
];
exports.StoredPaymentMethodType = typebox_1.Type.Union(exports.StoredPaymentMethodTypes.map((type) => typebox_1.Type.Literal(type)));
const isStoredPaymentMethodType = (value) => exports.StoredPaymentMethodTypes.includes(value);
exports.isStoredPaymentMethodType = isStoredPaymentMethodType;
//# sourceMappingURL=stored-payment-method-type.js.map